import React from 'react';

import NoticeModal from '../../../DesignSystem/NoticeModal/NoticeModal';
import { useChangeAddressStepHook } from '../logic/useStepHook';
import { WizardFlowActionType } from '../logic/WizardContext';
import { ReactComponent as LocationIcon } from '../../../assets/icons/svg/shared/ic-shared-location-error.svg';

export interface ChangePersonalAddressProps {
  onClose: () => void;
}
export const ErrorView = ({ onClose }: ChangePersonalAddressProps) => {
  const { dispatch, t, data } = useChangeAddressStepHook({});
  const { error } = data;

  if (!error || !error.errorKey) return <> Something Went Wrong </>;
  const { errorKey } = error;
  const title = t(`CHANGE_ADDRESS.ERRORS.${errorKey}.title` as const);
  const description = t(`CHANGE_ADDRESS.ERRORS.${errorKey}.description` as const);
  const button1Text = t('CHANGE_ADDRESS.ERRORS.button1Text');
  const button2Text = t('CHANGE_ADDRESS.ERRORS.button2Text');
  const handleRetry = () => {
    dispatch({ type: WizardFlowActionType.SET_STEP, payload: 0 });
  };
  const content = (
    <div className=' mb-[48px] text-center gap-1 inline '>
      <span className='text-bw08 text-[14px] font-metricR text-center ' id='description'>
        {description}
        {'  '}
      </span>
      {description.includes('contact us') && (
        <a
          className='font-metricR text-[14px] text-action03 hover:underline  text-center'
          href='mailto:support@lili.co'
          target='_blank'
          rel='noreferrer'
        >
          support@lili.co
        </a>
      )}
    </div>
  );
  return (
    <NoticeModal
      secondaryButtonText={button1Text}
      SvgComponent={LocationIcon}
      buttonText={button2Text}
      title={title}
      id='id'
      content={content}
      onSubmit={handleRetry}
      onClickOutside={onClose}
      shouldPersist
    />
  );
};
